<template>
  <div class="page-wrap">

    <div class="payStatus" v-if="payStatus!=0">
        <div v-if="payStatus==1">
            <img src="../../assets/images/pay-success.png" alt="" class="suc-logo" />
            <div class="status-text">支付成功！</div>
        </div>
        <div v-else>
            <img  src="../../assets/images/pay-error.png" alt="" class="store-logo" />
            <div class="status-text">支付失败！</div>
        </div>
    </div>


    <div class="page-load" v-if="pageLoading == 1">
      <img src="../../assets/images/loading.png" class="page-load_icon" />
    </div>
    <div class="notData" v-else-if="pageLoading == 2">
      {{ errMsg || "获取失败请稍后重试！" }}
    </div>

    <div v-else>
      
      <div class="ba-white merchantDate">
        <div class="labelItem">
          <span class="labelName">客户ID</span>
          <div class="labelContent">{{feeInfo.clientId}}</div>
        </div>
        <div class="labelItem">
          <span class="labelName">客户名称</span>
          <div class="labelContent">{{feeInfo.clientName}}</div>
        </div>
        <div class="labelItem">
          <span class="labelName">联系手机</span>
          <div class="labelContent">{{feeInfo.mobileNo}}</div>
        </div>
      </div>

      <!-- 单个缴费项：例如站点费 -->
      <div class="ba-white feeType-0" v-if="pageNav==0">
        <div class="labelItem">
          <span class="labelName">购买站点数</span>
          <div class="labelContent"> 
            <span>{{feeInfo.qty}}</span>
          </div>

        </div>
        <div class="labelItem">
          <span class="labelName">站点费价格</span>
          <div class="labelContent">￥{{feeInfo.price}}/个</div>
        </div>


      </div>

      <!--多选缴费， 例如： 服务费 -->
      <div class="ba-white feeType-1" v-else-if="pageNav==1">
        <div class="labelItem">
          <span class="labelName">缴纳服务费数量</span>
          <div class="labelContent"> 
            <span>{{feeInfo.qty}}</span>
          </div>

        </div>
        <div class="labelItem">
          <span class="labelName">服务费价格</span>
          <div class="labelContent">￥{{feeInfo.price}}/个</div>
        </div>


      </div>

      <!-- 小程序费用 -->
      <div class="ba-white feeType-2" v-else-if="pageNav==2">
        <div class="labelItem">
          <span class="labelName">小程序费用</span>
          <div class="labelContent">￥{{feeInfo.price}}</div>
        </div>
      </div>

      <!--单选类型： 短信费 -->
      <div class="feeType-3" v-else-if="pageNav==3">
        <div class="rowCenter dataItem">
            <span class="number">{{feeInfo.payment}}</span>
            <span>元</span>
            <span class="number">{{feeInfo.qty}}</span>
            <span>条</span>
            <span class="tips">({{feeInfo.price}}/条)</span>
        </div>

      </div>

      <!-- 底部 分享、支付 -->
      <div class="oper-bottom_back"></div>
      <div class="oper-bottom" :class="['color'+pageNav]">
        <div class="row" style="align-items: flex-end;  justify-content: space-between;">
          <div>
            <span v-if="totalPrice.payment">
              <span>合计：</span>
              <span class="fc-main price">
                <span>￥</span>
                <span class="numb">{{totalPrice.intNumb}}</span>
                <span>{{totalPrice.decNumb}}</span>
              </span>
            </span>
          </div>
          <button class="bg-main btn" :disabled="!totalPrice.payment || btnDisabled"  @click="handerPay">{{btnDisabled?"支付中..":"立即支付"}}</button>
        </div>
      </div>

    </div>

 
  </div>
</template>

<script>
  import { getOpenIdApi,queryRechargeDetailApi,createOrderApi,linfengPayApi } from "@/request/api";
  import { Toast } from 'vant'; 
  export default {
    name:'',
    components: {},
    data() {
        return {
            pageNav: 1, //0站点费、1服务费、2小程序费用、3短信费
            appId: 'wxad104e066a4e583a',  //公众号appId
            flowId: "",
            pageLoading: 1, //0 加载完成 1 加载中 2失败 
            payStatus:0,// 0：未支付 1：已支付 2：支付失败
            errMsg: "",

            code: '',           //公众号code
            openId: '',         //公众号openId

            feeInfo: {}, //费用类型缴费金额
            feeNumber: "",
            totalPrice: {
                intNumb: "",
                decNumb: "",
                payment: ""
            },
            btnDisabled: false, 


            enrollState:1,//0未注册的（代表客户）
         
        };
    },
    mounted() {
      
    },
    created () {

         this.flowId = this.$route['query']['key'];
          if (!this.flowId) {
            this.errMsg="参数错误，请联系客服重新获取链接";
            this.pageLoading=2;
            return
          }
          this.IsWeixinOrAlipay();

    },
    methods: {

     //判断扫码环境
      IsWeixinOrAlipay () {
        let that = this;
        var ua = window.navigator.userAgent.toLowerCase();
        let platform="";
        //判断是不是微信
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
          platform = "WX";
        }

        

        // localStorage.removeItem("openId");
        if (platform == "WX") {
          //查询缓存中是否存在openid，存在则执行业务操作，不存在则获取code，请求接口获得openid操作
          that.openId = localStorage.getItem("openId");

          if (!that.openId || that.openId == "" || that.openId == null || that.openId == undefined || that.openId == "null") {
            //获取微信openid
            that.getBaseInfos();
          }else{
            that.getRechargeDetail();  //获取信息
          }
        } else {
          //哪个都不是
          that.$router.replace({
            path: "/unableplat"
          })
        }
      },


      getRechargeDetail(){
        queryRechargeDetailApi({
            flowId:this.flowId,
        }).then(res=>{
            if(res.code==200){
                let pageNav = res.data.feeType;
                let title = ["缴站点费", "服务费", "小程序费", "短信费"][pageNav] || "天美联盟软件";
                document.title = title;

                //  pageTitle: title,
                this.pageNav=pageNav;
                this.pageLoading=0;
                this.feeInfo= res.data;
                this.payStatus=res.data.payStatus||0;
                this.countSum(res.data.payment)
            }else{
                this.pageLoading=2;
                this.errMsg=res.msg;
            }
        }).catch(err => {
            this.pageLoading=2;
            this.errMsg="请求网络繁忙，请稍后再试！";
        })
      

      },

         //获取code
      getBaseInfos () {
        let that = this;
        let url = window.location.href;
        that.code = that.getUrlParam('code');
        if (that.code) {
         that.getRechargeDetail();  //获取信息
         that.getOpenId();   //继续下一步获取openid
       
        } else {
         var url_code = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + that.appId + "&redirect_uri=" + that.urlencode(url) + "&response_type=code&scope=snsapi_base&state=h5#wechat_redirect";
         window.location.replace(url_code);//打开这个链接，你的url后面就会跟上code的参数 
       
        }
      },
      //获取openid
      getOpenId () {
        let that = this;
        const para = {
          'code': that.code,
          'payType': "WX"
        }
        getOpenIdApi(para).then(res => {
          if (res.code == 200) {
            if(res.data && res.data != "" && res.data != "null" && res.data != null && res.data != undefined){
              that.openId = res.data;
              localStorage.setItem("openId", that.openId); //缓存openid
            }
          } else {
            Toast(res.msg || "获取登录信息繁忙，请稍后重试！");
          }
        });
      },
      //编码函数
      urlencode (str) {
        str = (str + '').toString();
        return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').
          replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+');
      },
      //获取url链接中的参数，二维码中的参数
      getUrlParam (key) {
        var reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)', 'i');
        var r = window.location.search.substr(1).match(reg);
        if (r != null) {
            return decodeURIComponent(r[2]);
        }
        return null;

      },


        countSum(price) {
            let str = price.toString().split(".");
            this.totalPrice={
                intNumb: str[0],
                decNumb: str[1] ? ("." + str[1]) : "",
                payment: price
            }
        },
        //支付
        handerPay(){
            if(this.btnDisabled){
             return
            }
            this.btnDisabled=true;
            let feeInfo=this.feeInfo;

            createOrderApi({ flowId:this.flowId}).then(order_res=>{
                if(order_res.code==200){
                    linfengPayApi({
                        appId:this.appId,
                        outerTradeId:order_res.data.tradeId,
                        flowId:feeInfo.flowId,
                        payment:feeInfo.payment,
                        price:feeInfo.price,
                        qty:feeInfo.qty,
                        openId:this.openId,
                    }).then(res=>{
                        this.goWxpay({
                          timeStamp:res.data.timeStamp,
                          package:"prepay_id="+res.data.prepayId,
                          paySign:res.data.paySign,
                          appId:this.appId,
                          signType:res.data.signType,
                          nonceStr:res.data.nonceStr
                        })

                    }).catch(err=>{
                        this.btnDisabled=false;
                    })
                }else{
                     this.btnDisabled=false;
                }
               
            }).catch(err=>{
                this.btnDisabled=false;
            })

        },

        //唤起微信支付
        goWxpay (jsApiPayInfo) {
            let that=this;
            window.WeixinJSBridge.invoke(
            'getBrandWCPayRequest',
            jsApiPayInfo,
            function (res) {
                // Toast('支付回调参数：'+JSON.stringify(res));
                //成功后返回ok，但并不保证它绝对可靠，继续请求接口查询是否真的支付成功
                if (res.err_msg == "get_brand_wcpay_request:ok") {   
                that.getRechargeDetail();
                }else if(res.err_msg == "get_brand_wcpay_request:cancel"){ 
                //取消支付
                }else if(res.err_msg == "get_brand_wcpay_request:fail"){ 
                    that.getRechargeDetail();
                    //支付失败
                    Toast("支付失败:"+JSON.stringify(res));
                }
                that.btnDisabled=false;
                // 使用以上方式判断前端返回,微信团队郑重提示：
                //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。

            }
            );
        }

    }
  }
</script>
<style lang="scss" scoped>
 .page-wrap{
    font-size: 28px;
 }
// 支付状态
 .payStatus{
    text-align: center;
    .suc-logo{
        margin-top: 78px;
        width: 104px;
        height: 87px;
        margin-bottom: 41px;
    }
    .store-logo{
        margin-top: 65px;
        width: 106px;
        height: 106px;
        margin-bottom: 35px;
    }
    .load-err{
        margin-top: 66px;
        width: 361px;
        height: 326px;
        margin-bottom: 56px;
    }
    .status-text{
        font-size: 36px;
        font-weight: bold;
        color: #FA3474;
    }
    .load-text{
        font-size: 36px;
        font-weight: bold;
        color: #999999;
    }
    }


// 付款内容
.row {display: flex;flex-flow: wrap row;}
.rowCenter {display: flex;flex-direction: row;align-items: center;}
button{
    outline: none;
    border: none;
}

.ba-white{
 background-color: #fff;
}
.labelItem{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-top: solid 1px #EFEFEF;
  padding: 32px 28px;
}
.labelName{
  flex: none;
}
.arrow-icon{
  width: 26px;
  height: 26px;
}
.warn-icon{
  width: 45px;height: 38px;margin-right: 12px;
  flex: none;
}

/* 底部操作 */
.oper-bottom_back {
  min-height: 120px;
  box-sizing: content-box;
  padding-bottom: env(safe-area-inset-bottom);
}

.oper-bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 90;
  background-color: #fff;
  min-height: 120px;
  padding: 21px 24px env(safe-area-inset-bottom);
  font-size: 30px;
  font-weight: 700;
//   --color:#07C160;
}
.oper-bottom .price{
  color:#07C160;
}
.oper-bottom .numb{
  font-size: 46px;
}

.oper-bottom .btn {
  width: 324px;
  height: 78px;
  line-height: 78px;
  font-size: 30px;
  font-weight: 400;
  color: #fff;
  padding: 0;
  margin: 0;
  border-radius: 6px;
  text-align: center;
  background-color: #07C160;
}
.oper-bottom button[disabled]{
  background-color: #999;
  color: #fff;
}

.feeType-0 ,.feeType-1 ,.feeType-2 {
  margin-top: 24px;
}

/* 
* 短信费
*/
.feeType-3{
  padding-bottom: 10px;
}
.feeType-3 .dataItem{
  background-color: #fff;
  margin: 30px 30px 0;
  border-radius: 12px;
  padding: 40px 30px;
  font-size: 26px;
}
.feeType-3 .number{
  color: #FA3B79;
  font-weight: 700;
  font-size: 48px;
  margin: 0 4px;
}
.feeType-3 .tips{
  color: #999;
}



/* 加载中 */
.page-load{
  padding-bottom: 20px;
  margin: 80px 0 30px;
  text-align: center;
}
.page-load_2{
  padding: 28px 0;
  text-align: center;
}

.page-load_icon{
    width: 52px;
    height: 52px;
    display: inline-block;
    margin: auto;
    animation: load_img linear infinite 1s;
}

@keyframes load_img {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
  
}
.notData,.noData {
  padding: 80px 30px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 28px;
  color: #666;
}


</style>